export default {
  SET_SUCCESS_GOVERNMENTS: (state, success) =>
    (state.governments_success = success),
  SET_SUCCESS_REGiONS: (state, success) => (state.regions_success = success),
  SET_SUCCESS_COST: (state, success) => (state.cost_success = success),
  SET_SUCCESS_AREA_COST: (state, success) => (state.area_cost_success = success),
  SET_ERRORS: (state, errors) => (state.errors = errors),
  SET_ERROR_MSG: (state, error_msg) => (state.error_msg = error_msg),
  SET_GOVERNMENTS: (state, governments) => (state.governments = governments),
  SET_REGiONS: (state, regions) => (state.regions = regions),
  SET_REQUIRED_REGiONS: (state, required_regions) => (state.required_regions = required_regions),
  SET_COST: (state, cost) => (state.cost = cost),
  SET_AREA_COST: (state, area_cost) => (state.area_cost = area_cost),
};
